export default function validateGender(gender = "", { optional } = { optional: false }) {
  const error = [];

  if (!optional || gender) {
    if (!["MALE", "FEMALE"].includes(gender)) error.push(`Invalid gender`);
  }

  return error.join(" ");
}
